<template>
	<div class="payment-options" :class="{ grid: options.length >= 4 }">
		<div
			v-for="option in options"
			:key="option.id"
			class="button-wrapper"
			:data-cy="`payment-option-${option.id}`"
		>
			<button
				class="button button-auto"
				:class="{
					'button-secondary-dark': option.id == model,
					'button-outline': option.id != model
				}"
				@click="paymentMethodClicked(option.id)"
			>
				<span v-if="option.text">{{ option.text }}</span>
				<i v-if="option.icon" :class="option.icon"></i>
			</button>
		</div>
		<button
			id="sq-google-pay"
			ref="googlePayBtn"
			style="display: none"
		></button>
		<button
			id="sq-apple-pay"
			ref="applePayBtn"
			style="display: none"
		></button>
	</div>
</template>

<style scoped>
.payment-options {
	margin-bottom: 20px;
	min-height: 35px;
	display: flex;
}

.payment-options.grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 10px;
	grid-row-gap: 10px;
}

.payment-options.grid .button {
	margin: 0 !important;
}

.payment-options .button {
	min-height: 35px;
	padding: 10px 30px;
	align-items: center;
	display: flex;
}

.payment-options .button-wrapper + .button-wrapper .button {
	margin-left: 38px;
}

.payment-options i {
	font-size: 32px;
	margin-right: 0;
}

.button-wrapper {
	display: flex;
	justify-content: center;
}

.button.button-secondary-dark span {
	color: var(--gR-white);
}

.button span {
	color: var(--gR-base-80);
	font-weight: 600;
}

@media only screen and (max-width: 700px) {
	.payment-options {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 10px;
		grid-row-gap: 10px;
		height: auto;
	}

	.payment-options .button {
		margin: 0 !important;
	}
}
</style>

<script>
export default {
	name: "PaymentOptions",
	props: {
		value: null,
		options: {
			default: () => [],
			type: Array
		}
	},
	computed: {
		model: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit("input", val)
			}
		}
	},
	methods: {
		paymentMethodClicked(method) {
			this.$emit("methodSelected", method)
		}
	}
}
</script>